import React, { useEffect, useState } from 'react'
import {Card,CardContent} from '@material-ui/core'
import {Line } from 'react-chartjs-2'
import './LineGraph.css'

function LineGraph() {
    const [dataChart,setDataChart]=useState({});
    useEffect(()=>{
        let dateOfPoll=[];
        let truePoll=[];
        let falsePoll=[];
        const fetchTrue=async()=>{
            await fetch('https://onevotematters.herokuapp.com/countT?voting_choice=true')
                .then((response)=>response.json())
                .then((data)=>{
                    for(let dataTrue of data.data){
                        dateOfPoll.push(dataTrue.date);
                        truePoll.push(parseInt(dataTrue.counts));
                    }
                });
        };
        const fetchFalse=async()=>{
            await fetch('https://onevotematters.herokuapp.com/countF?voting_choice=false')
                .then((response)=>response.json())
                .then((data)=>{
                    for(let dataFalse of data.data){
                        falsePoll.push(parseInt(dataFalse.counts));
                    }
                })
        };
        setDataChart({
            labels:dateOfPoll,
            datasets:[
                {   //yes 
                    label:'Person with Yes',
                    data:truePoll,
                    borderColor:['rgba(51,255,0,0.2)'],
                    backgroundColor:['rgba(51,255,0,0.2)'],
                    pointBackgroundColor:'rgba(51,255,0,0.2)',
                    pointBorderColor:'rgba(51,255,0,0.2)'   
                },
                {   //no
                    label:'Person with No',
                    data:falsePoll,
                    borderColor:['rgba(255, 99, 132, 0.2)'],
                    backgroundColor:['rgba(255, 99, 132, 0.2)'],
                    pointBackgroundColor:'rgba(255, 99, 132, 0.2)',
                    pointBorderColor:'rgba(255, 99, 132, 0.2)'
                }
            ]

        });

        fetchTrue();
        fetchFalse();

    },[]);

    const options = {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      }
    return (
        <>
            <Card className="lineStyle">
                <CardContent>
                    <h1>Visualization of Result</h1>
                </CardContent>
                <Line height="600px" width="800px" data={dataChart} options={options} />
            </Card>
        </>
    )
}

export default LineGraph
